import { render, staticRenderFns } from "./DepotOut.vue?vue&type=template&id=3724b824&scoped=true"
import script from "./DepotOut.vue?vue&type=script&lang=js"
export * from "./DepotOut.vue?vue&type=script&lang=js"
import style0 from "./DepotOut.vue?vue&type=style&index=0&id=3724b824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724b824",
  null
  
)

export default component.exports